import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import { DBDocumentQuestionSchema, DocumentQuestionSchema } from './schemas';

export const DocumentQuestionCodecConfig: TransformerConfig<
  typeof DocumentQuestionSchema,
  typeof DBDocumentQuestionSchema
> = {
  name: 'DocumentQuestion',
  clientSchema: DocumentQuestionSchema,
  dbSchema: DBDocumentQuestionSchema,
  transformers: [
    createTimestampTransformer<typeof DocumentQuestionSchema, typeof DBDocumentQuestionSchema>(
      'createdAt'
    ),
    createTimestampTransformer<typeof DocumentQuestionSchema, typeof DBDocumentQuestionSchema>(
      'updatedAt',
      { nullable: true }
    ),
  ],
};

export const encodeDocumentQuestionToDb = createEncodeToDbFn(DocumentQuestionCodecConfig);
export const decodeDocumentQuestionFromDb = createDecodeFromDbFn(DocumentQuestionCodecConfig);
